/**
 * A portal page loaded on demand (its own chunk), with its own Suspense boundary:
 * PortalLayout has none, and adding one there would touch every portal route. Eagerly
 * imported portal pages never suspend and are left exactly as they were. A chunk that cannot
 * be fetched shows PageLoadError (with a reload button), as routes/public.jsx's lazyPage does.
 * `displayName` keeps the page's name in route tooling and tests.
 *
 * Shared by routes/business.jsx (Phase 7b–7d, 8B) and routes/venue.jsx (Phase 8B). Not a route
 * file: it declares no routes and imports no page.
 */
import React, { Suspense, lazy } from "react";
import { PageLoading, PageLoadError } from "../layouts/PageStates";

export default function lazyPortalPage(name, load) {
  const Page = lazy(() => load().catch(() => ({ default: PageLoadError })));
  const Lazy = () => (
    <Suspense fallback={<PageLoading />}>
      <Page />
    </Suspense>
  );
  Lazy.displayName = name;
  return Lazy;
}
